/* TAG Drop 02 - heat lattice.
   Hairline grid warped by a live heat-shimmer field, drawn as GLOW ONLY:
   transparent everywhere the lines are not, so it never hides artwork.
     constant: two crossing sine fields shimmer the grid + an auto shockwave every ~5s
     scroll  : px/sec velocity raises amplitude, thickness and brightness, spawns
               ripples, and past a threshold splits the lattice chromatically
     tap     : shockwave ring from the contact point that bends the grid
   Raw WebGL, one triangle, no library. DPR 1 on phones. Pauses off-screen. */
(function () {
  var VS = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
  var FS = [
    'precision mediump float;',
    'uniform vec2 u_res;uniform float u_time;uniform float u_vel;uniform float u_amt;uniform float u_sp;',
    'uniform vec3 u_c1;uniform vec3 u_c2;uniform vec3 u_ice;uniform vec4 u_rip[4];',
    'float lm(float v,float w){return smoothstep(w,0.0,abs(v));}',
    'void main(){',
    'vec2 uv=gl_FragCoord.xy/u_res.xy;',
    'float ar=u_res.x/u_res.y;',
    'vec2 p=vec2(uv.x*ar,uv.y);',
    'float t=u_time;',
    'float energy=u_amt*(1.0+0.85*u_vel);',
    'vec2 w=vec2(0.0);',
    'w.x+=sin(p.y*9.0+t*1.5)*0.012;',
    'w.y+=sin(p.x*7.0-t*1.1)*0.014;',
    'w.x+=sin(p.y*23.0-t*3.0)*0.005;',
    'w.y+=sin(p.x*17.0+t*2.2)*0.0055;',
    'w*=(0.9+2.4*u_vel);',
    'float rim=0.0;',
    'for(int i=0;i<4;i++){',
    ' vec4 r=u_rip[i];',
    ' float on=step(0.001,r.w);',
    ' vec2 o=vec2(r.x*ar,r.y);',
    ' float d=distance(p,o);',
    ' float age=max(0.0,t-r.z);',
    ' float band=d-age*0.5;',
    ' float life=exp(-age*1.1)*r.w*on;',
    ' float ring=exp(-band*band*220.0)*life;',
    ' w+=normalize(p-o+vec2(0.0001))*ring*0.065;',
    ' rim+=ring;',
    '}',
    'vec2 g=p+w;',
    'vec2 cell=fract(g/u_sp)-0.5;',
    'float lw=0.085+0.06*u_vel;',
    'float grid=max(lm(cell.x,lw),lm(cell.y,lw));',
    'float hot=smoothstep(1.3,-0.1,uv.y);',
    'float amp=length(w)*32.0;',
    'float glow=grid*(0.62+0.5*hot+0.9*amp)*energy;',
    'vec3 col=u_c1*glow;',
    'col+=u_c2*grid*amp*0.8*energy;',
    'col+=u_c2*rim*1.7+u_ice*rim*0.8;',
    'float split=max(0.0,u_vel-0.22);',
    'vec2 c2=fract((g+vec2(0.006*u_vel,0.0))/u_sp)-0.5;',
    'float grid2=max(lm(c2.x,lw),lm(c2.y,lw));',
    'col+=u_ice*grid2*split*1.2;',
    'float a=clamp(max(col.r,max(col.g,col.b)),0.0,1.0);',
    'gl_FragColor=vec4(col,a);',
    '}'
  ].join('\n');

  function hex(c, fb) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((c || '').trim());
    if (!m) return fb;
    return [parseInt(m[1], 16) / 255, parseInt(m[2], 16) / 255, parseInt(m[3], 16) / 255];
  }

  function build(host) {
    if (host.dataset.latOn) return;
    host.dataset.latOn = '1';

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { host.classList.add('lat-static'); return; }
    var mobile = innerWidth < 750;
    var cv = document.createElement('canvas');
    cv.className = 'tagx-lat__canvas';
    var gl = cv.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power' });
    if (!gl) { host.classList.add('lat-static'); return; }
    host.appendChild(cv);

    function sh(ty, src) {
      var s = gl.createShader(ty); gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn('[lattice]', gl.getShaderInfoLog(s)); return null; }
      return s;
    }
    var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) { host.classList.add('lat-static'); cv.remove(); return; }
    var pr = gl.createProgram();
    gl.attachShader(pr, vs); gl.attachShader(pr, fs); gl.linkProgram(pr); gl.useProgram(pr);

    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    var b = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var al = gl.getAttribLocation(pr, 'p');
    gl.enableVertexAttribArray(al);
    gl.vertexAttribPointer(al, 2, gl.FLOAT, false, 0, 0);

    var U = {};
    ['u_res', 'u_time', 'u_vel', 'u_amt', 'u_sp', 'u_c1', 'u_c2', 'u_ice'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    U.rip = gl.getUniformLocation(pr, 'u_rip[0]');

    gl.uniform3fv(U.u_c1, hex(host.dataset.latC1, [1, 0.35, 0.12]));
    gl.uniform3fv(U.u_c2, hex(host.dataset.latC2, [1, 0.54, 0.24]));
    gl.uniform3fv(U.u_ice, hex(host.dataset.latIce, [0.16, 0.83, 1]));
    gl.uniform1f(U.u_amt, parseFloat(host.dataset.latAmt || '1'));
    gl.uniform1f(U.u_sp, parseFloat(host.dataset.latSp || (mobile ? '0.07' : '0.045')));

    var dpr = Math.min(devicePixelRatio || 1, mobile ? 1 : 1.5);
    function size() {
      var r = host.getBoundingClientRect();
      var w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; gl.viewport(0, 0, w, h); gl.uniform2f(U.u_res, w, h); }
    }
    size();
    addEventListener('resize', size, { passive: true });

    var rip = new Float32Array(16), slot = 0, clock = 0;
    function shock(nx, ny, strength) {
      var o = slot * 4;
      rip[o] = nx; rip[o + 1] = ny; rip[o + 2] = clock; rip[o + 3] = strength;
      slot = (slot + 1) % 4;
    }
    function tapAt(e) {
      var pt = e.touches && e.touches[0] ? e.touches[0] : e;
      var r = host.getBoundingClientRect();
      shock((pt.clientX - r.left) / r.width, 1 - (pt.clientY - r.top) / r.height, 1.8);
    }
    var parent = host.parentElement || host;
    parent.addEventListener('pointerdown', tapAt, { passive: true });
    parent.addEventListener('touchstart', tapAt, { passive: true });

    var lastY = window.scrollY || 0, velTarget = 0, vel = 0, sinceScrollRip = 0, sinceAutoRip = 0;
    addEventListener('scroll', function () {
      var y = window.scrollY || 0;
      velTarget = Math.max(velTarget, Math.min(1, Math.abs(y - lastY) / 55));
      lastY = y;
    }, { passive: true });

    var vis = true, raf = 0, last = performance.now();
    var io = new IntersectionObserver(function (en) {
      vis = en[0].isIntersecting;
      if (vis && !raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
    }, { rootMargin: '100px' });
    io.observe(host);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && vis && !raf) { last = performance.now(); raf = requestAnimationFrame(tick); }
    });

    function tick(now) {
      raf = 0;
      if (!vis || document.hidden) return;
      var dt = Math.min(0.05, Math.max(0.001, (now - last) / 1000));
      last = now; clock += dt;

      velTarget *= 0.88;
      vel += (velTarget - vel) * 0.18;

      sinceAutoRip += dt;
      if (sinceAutoRip > 4.5) { sinceAutoRip = 0; shock(0.25 + Math.random() * 0.6, 0.1 + Math.random() * 0.5, 0.7); }
      sinceScrollRip += dt;
      if (vel > 0.35 && sinceScrollRip > 0.4) { sinceScrollRip = 0; shock(Math.random(), 0.08 + Math.random() * 0.3, 1.0 * vel); }

      size();
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.uniform1f(U.u_time, clock);
      gl.uniform1f(U.u_vel, vel);
      gl.uniform4fv(U.rip, rip);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);
  }

  function init() { document.querySelectorAll('[data-lattice]').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
